import React from 'react';
import Header from '../../components/Layout/Header';
import InsightMain from '../../components/Insights';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
import Footer from '../../components/Layout/Footer';
import ScrollToTop from '../../components/Common/ScrollTop';
import SearchModal from '../../components/Layout/Header/SearchModal';

// Breadcrumbs Background Image
import bannerbg from '../../assets/img/breadcrumbs/4.jpg';

const Insights = () => {
    return (
        <React.Fragment>
            <Header
                parentMenu='Insights'
                activeMenu='/insights'
            />
            <div>
                <SiteBreadcrumb
                    pageTitle="Insight"
                    titleClass="page-title"
                    pageName="Insight"
                    breadcrumbsImg={bannerbg}
                />

                {/* Blog Main */}
                <InsightMain />
                {/* Blog Main End */}

                {/* scrolltop-start */}
                <ScrollToTop />
                {/* scrolltop-end */}

            </div>
            <Footer />
            <SearchModal />
        </React.Fragment>
    );
}


export default Insights;

